// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1lQfV","info":"UpdateTermsInfo_info__xbZjM"};